module.exports = __webpack_public_path__ + "media/images/thank-mobile-d2e223245fc998f12f5c8ff9c39847ea.jpg";